/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%}[_nghost-%COMP%]   .happ-list-hover[_ngcontent-%COMP%]{background:#fff;cursor:pointer;border:1px solid #e6dcdc}"];
export { styles as styles };
